import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=6023509e&scoped=true&"
import script from "./Denied.vue?vue&type=script&lang=js&"
export * from "./Denied.vue?vue&type=script&lang=js&"
import style0 from "./Denied.vue?vue&type=style&index=0&id=6023509e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023509e",
  null
  
)

export default component.exports